// components/MobileLayout/index.tsx

import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import clsx from "clsx";
import { Icon } from "../../Icon";
import * as MUIIcon from "react-icons/md";
import { PRIVATE_ROUTES } from "configs/routes";
import { MenuChildrenType, MenuType } from "contexts/TabsMenuContext/types";
import { Button } from "components/Button";
import { useTranslation } from "react-i18next";

// ─── Bottom nav items ────────────────────────────────────────────────────────
// const NAV_ITEMS: {
//   label: string;
//   icon: keyof typeof MUIIcon;
//   path: string;
// }[] = [
//   { label: "Home", icon: "MdHome", path: "/dashboard" },
//   { label: "Analytics", icon: "MdDetails", path: "/analytics" },
//   { label: "Alerts", icon: "MdNotifications", path: "/alerts" },
//   { label: "Profile", icon: "MdPerson", path: "/profile" },
//   { label: "Settings", icon: "MdSettings", path: "/settings" },
// ];
const NAV_ITEMS: Array<MenuChildrenType & { iconName: keyof typeof MUIIcon }> =
  PRIVATE_ROUTES
    .filter((item): item is MenuType & { iconName: keyof typeof MUIIcon } =>
      item.iconName !== undefined
    )
    .flatMap((item) =>
      item.children.map((child) => ({ ...child, iconName: item.iconName }))
    )
    .filter((item) => item.name.includes("install"));
//     .map((child) => ({
//   label: child.label,
//   icon: "MdSettings" as keyof typeof MUIIcon,
//   path: child.path,
// }));
// const NAV_ITEMS: {
//   label: string;
//   icon: keyof typeof MUIIcon;
//   path: string;
// }[] = PRIVATE_ROUTES.flatMap((item) => ({
//   ...item.children,
//   icon: item.iconName,
// }));
//     .map((child) => ({
//   label: child.label,
//   icon: child.icon as keyof typeof MUIIcon,
//   path: child.path,
//   name: child.name,
// }));
// .filter((item) => item?.name?.includes("install"));

// ─── Component ───────────────────────────────────────────────────────────────
const MobilePrivateLayout: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  console.log("!!", NAV_ITEMS);
  const { t } = useTranslation();

  // Active bottom-nav item: match by prefix so nested routes highlight correctly
  const activeNav = NAV_ITEMS.find((item) => pathname.startsWith(item.path));

  // Ripple state per nav item
  const [ripple, setRipple] = useState<string | null>(null);

  const triggerRipple = (path: string) => {
    setRipple(path);
    setTimeout(() => setRipple(null), 350);
  };

  const goHome = () => {
    navigate("/dashboard");
  };

  return (
    <div className="flex flex-col h-screen w-full bg-neutral-15 overflow-hidden">
      {/* ── Top Bar ─────────────────────────────────────────────────────── */}
      <header
        className="
        relative z-20 h-14 px-4 flex justify-center items-center
        bg-white border-b border-neutral-100 shadow-sm
        safe-area-top
      "
      >
        <Button
          onClick={goHome}
          className={"absolute flex h-full items-center right-0 top-0"}
          variant={"text"}
        >
          <Icon fontSize={"22"} icon={"MdHome"} />
        </Button>

        {/* Page title — centered */}
        <h1
          className="
          flex-1 text-center text-[15px] font-semibold
          text-neutral-900 tracking-tight truncate px-2
        "
        >
          {t("installation")}
        </h1>
      </header>

      {/* ── Page Content ────────────────────────────────────────────────── */}
      <main
        className="flex-1 overflow-y-auto overflow-x-hidden min-h-0"
        style={{ border: "1px solid red" }}
      >
        {children ?? <Outlet />}
      </main>

      {/* ── Bottom Navigation Bar ───────────────────────────────────────── */}
      <nav
        className="
        relative z-20 flex items-stretch h-16
        bg-white border-t border-neutral-100
        safe-area-bottom
      "
      >
        {NAV_ITEMS.map(({ title, iconName, path }) => {
          const isActive = activeNav?.path === path;

          return (
            <button
              key={path}
              onClick={() => {
                triggerRipple(path);
                navigate(path);
              }}
              aria-current={isActive ? "page" : undefined}
              className={clsx(
                "relative flex flex-1 flex-col items-center justify-center gap-[3px] overflow-hidden",
                "transition-colors duration-150 select-none",
                isActive
                  ? "text-blue-600"
                  : "text-neutral-400 hover:text-neutral-600"
              )}
            >
              {/* Active indicator pill */}
              <span
                className={clsx(
                  "absolute top-0 left-1/2 -translate-x-1/2 h-[2.5px] rounded-b-full",
                  "bg-blue-600 transition-all duration-200",
                  isActive ? "w-8 opacity-100" : "w-0 opacity-0"
                )}
              />

              {/* Ripple ring */}
              {ripple === path && (
                <span
                  className="
                  absolute inset-0 m-auto w-10 h-10 rounded-full
                  bg-blue-100 opacity-60
                  animate-ping pointer-events-none
                "
                />
              )}

              <Icon
                fontSize={"20"}
                className="transition-transform duration-150 active:scale-90"
                icon={iconName}
              />
              <span
                className={clsx(
                  "text-[10px] font-medium tracking-wide",
                  isActive ? "text-blue-600" : "text-neutral-400"
                )}
              >
                {title}
              </span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default MobilePrivateLayout;
